<template>
  <ImportSourceCard
    :import-source="handSearch"
    :is-expanded="isExpanded"
    :is-highlighted="isHighlighted"
    @import-source-removed="emit('importSourceRemoved')"
    @toggle-expanded="emit('toggleExpanded', $event)"
  >
  </ImportSourceCard>
</template>
<script setup lang="ts">
import ImportSourceCard from "../../Components/ImportSourceCard.vue";

import { BuiltInImportSourceId } from "@core/domain/types/builtInImportSourceId";
import useBuiltInImportSources from "@app/composables/use-built-in-import-sources";

const builtInImportSources = useBuiltInImportSources();
const emit = defineEmits<{
  (e: "importSourceRemoved"): void;
  (e: "toggleExpanded", event: MouseEvent): void;
}>();

defineProps<{
  isExpanded?: boolean;
  isHighlighted?: boolean;
}>();

const handSearch = builtInImportSources.findById(BuiltInImportSourceId.HAND_SEARCH)!;
</script>
